import { AutocompleteOption, SelectData } from '@occc-app/design-system';
import { Site_System_Connection_Action, Site_System_Connection_Status } from '@occc/graphql';

export const CONNECTIVITY_STATUS_OPTIONS: SelectData<Site_System_Connection_Status | ''>[] = [
  { value: '', label: 'View All' },
  { value: Site_System_Connection_Status.Connected, label: 'Connected' },
  { value: Site_System_Connection_Status.ConnectionFailure, label: 'Connection Failure' },
  { value: Site_System_Connection_Status.Disconnected, label: 'Disconnected' },
];

export const DISCONNECT_REASON_OPTIONS: AutocompleteOption[] = Object.values(
  Site_System_Connection_Action,
).map((action) => ({
  value: action,
  label: action,
}));
